// export const FETCH_ALL_NFTS = `query{
//   list_all_processing_nfts{
//    message
//    data {
//      _id
//      provider
//      profile_url
//      nft_status
//      qr_url
//      user_id {
//        _id
//        email
//        name
//      }
//    }
//  }
//  }
// `;

export const FETCH_ALL_NFTS = `query{
  list_all_nfts{
    message
    data {
      _id
      qr_url
      nft_status
      email
      name
    }
  }
}`;

export const UPDATE_NFT_DATA = `mutation ($socAccId: String!, $nftAddress: String!) {
  update_nft_address(soc_acc_id: $socAccId, nft_address: $nftAddress) {
    message
  }
}
`;
